import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading
  },
  data: function() {
    return {
      emailIdValidationMSG:'',
      hubid:'',
      emailIdErrorMSG:"",
      mailId:'',
      showemailpage:false,
      isLoading: false,
      showTable: true,
      lineHaulObjData: {
        coloadername: "",
        routemode: "",
        vehiclename: "",
        vehicleno: "",
        awbno: "",
        pcs: "",
        physicalweight: "",
        volumetricweight: "",
        boggieno: "",
        breakno: "",
        traintype: "",
        rrno: "",
        rrno1: "",
        rrno2: "",
        departuredate: "",
        departuretime: "",
        scheduledate: "",
        arrivaldate: "",
        arrivaltime: "",
        printDate: "", //
        printBy: "", //
        connectionname: "",
        departuredate: "",
        departuretime: "",
        noofbags: "",
      },
      lineHaulShipmentObjData: [{
        bagtype: "",
        bagno: "",
        parentBags: "",
        totalShipments: "",
        destinationhubid: "",
        physicalweight: "",
        volumetricweight: ""
      }],
      printDate: '',
      printBy: '',
      isDisplay: true,
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  created: function() {},
  model: {
    totalVolWt: 0,
    totalPhyWt: 0,
    totalLineHaulBags: 0,
    totalBags: 0,
    totalShipments: 0
  },
  computed: {
    TotalVolWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalVolWt, item) {
        var totalVolWt = totalVolWt + parseFloat(item.volumetricweight);
        //return totalVolWt.toFixed(3);
        return totalVolWt;
      }, 0);
    },
    TotalPhyWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalPhyWt, item) {
        var totalPhyWt = totalPhyWt + parseFloat(item.physicalweight);
        //return totalPhyWt.toFixed(3);
        return totalPhyWt;
      }, 0);
    },
    TotalLineHaulBags: function() {
      return this.lineHaulShipmentObjData.length
    },
    TotalBags: function() {
      return 0;
      // return this.lineHaulShipmentObjData.reduce(function(totalBags, item) {
      // 	return totalBags + parseFloat(item.volumetricweight);
      // }, 0);
    },
    TotalShipments: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalShipments, item) {
        return totalShipments + parseFloat(item.totalshipments);
      }, 0);
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email
    this.loadLineHaulDetails();
    this.hubid=userdetail[0].HubId[0];
    // this.loadShipmentsDetails();
  },
  methods: {
    SendMailFunction(){
      this.emailIdValidationMSG=''
      this.emailIdErrorMSG=''
      if(this.mailId =='' || this.mailId == undefined)
      {
        this.emailIdErrorMSG="Enter Email-Id"
        return false
      }
      var mailArray=[];
      mailArray = this.mailId.split(',');
      for(var i=0;i<mailArray.length;i++)
    {
      if(this.regForMail.test(mailArray[i]) == false)
      {
        this.emailIdValidationMSG="Invalid MailId"+" "+mailArray[i]
        return false
      }
    }
      this.input = {
        "LineHaulDetailsID":this.$route.params.LineHaulDetailsID,
        "ConfirmLineHaulDetailsID":this.$route.params.ConfirmLineHaulDetailsID,
        "HubID":this.hubid,
        "To":this.mailId
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops  + 'emailPreAlert',
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          // console.log(response);
          if (response.ResultCode == 100) {
            this.$alertify.success(response.ReturnMessage)
            //this.showemailpage=false
            this.mailId=''
            this.closeSendMailPage()
            this.resetForm()
          } else {
            this.$alertify.error(response.ReturnMessage)
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })

    },
    resetForm(){
      this.mailId='',
      this.emailIdErrorMSG='',
      this.emailIdValidationMSG=''
    },
    sendMail(){

      this.showemailpage=true;

    },
    closeSendMailPage(){
      this.showemailpage = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.resetForm()
    },
    loadLineHaulDetails() {
      if (this.$route.params.LineHaulDetailsID && this.$route.params.ConfirmLineHaulDetailsID) {
        this.isLoading = true
        this.input = {}
        axios({
            method: 'GET',
            'url': apiUrl.allocateRuleapi_url + 'confirmLineHaulDetailsListAll?LineHaulDetailsID=' + this.$route.params.LineHaulDetailsID + '&ConfirmLineHaulDetailsID=' + this.$route.params.ConfirmLineHaulDetailsID,
            'data': this.input,
            headers: {
              'Authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            var response = result.data
            if (result.status == 200 && response.ResultCode == 100) {
              if (response.ResultData.length > 0) {
                this.lineHaulObjData = response.ResultData[0];
              }
              this.loadShipmentsDetails(this.$route.params.LineHaulDetailsID, this.$route.params.ConfirmLineHaulDetailsID)
            } else {
              this.isDisplay = false
              this.$alertify.error("No record found")
            }
            this.isLoading = false
          }, error => {
            this.isDisplay = false
            this.isLoading = false
            console.error(error)
          })
      } else {
        this.$alertify.error("Somethig wrong, Try again");
        this.isDisplay = false
      }
    },
    loadShipmentsDetails(LineHaulDetailsID, ConfirmLineHaulDetailsID) {
      this.input = {}
      axios({
          method: 'GET',
          'url': apiUrl.allocateRuleapi_url + 'getConfirmLineHaulBagDetailsPrealert?LineHaulDetailsID=' + LineHaulDetailsID + '&ConfirmLineHaulDetailsID=' + ConfirmLineHaulDetailsID,
          'data': this.input,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var response = result.data
          // console.log(response);
          if (result.status == 200 && response.ResultCode == 100) {
            if (response.ResultData.length > 0) {
              this.lineHaulShipmentObjData = response.ResultData;
            }
          } else {
            this.$alertify.error("No record found")
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    printLineHaul() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('lineHaulContent'), cssText);
    },
    toFixedVal(val) {
      // console.log(val);
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LineHaulPrint/LineHaulPrint.js